<wiz-vgroup width="100%" height="100%" gap="2" class="section-container">
  <!-- <wiz-hgroup width="100%" height="40px">
    <wiz-label #lbTitle width="100%" class="componentLabel"></wiz-label>
    <wiz-icon class="image-purple" (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup> -->

  <wiz-hgroup verticalAlign="center">
    <filter-component #popFilter width="100%"> </filter-component>
    <wiz-icon #icoUnselect [visible]="!!popupData?.value"
        (click)="askForUnselect()"
        style="cursor: pointer; font-size: 20px" tooltipPlacement="top"
        [wizTooltip]="'$.common.unselect.$'">delete</wiz-icon>
    <wiz-label [visible]="!!popupData?.value" wizLabel="$.common.unselect.$" (click)="askForUnselect()"></wiz-label> 
  </wiz-hgroup>


  <wiz-ag-grid
  #agGrid
  width="100%"
  height="100%"
  class="ag-theme-alpine"
  [columnDefs]="columns"
  [wizDatasource]="mainDS"
  [wizRowSelection]="'single'"
  ></wiz-ag-grid>

  <!-- <wiz-list #liKey width="100%" height="100%" [wizLabelField]="'fullStr'" [wizDataProvider]="mainDS"></wiz-list> -->
  <wiz-hgroup width="100%" verticalAlign="end" horizontalAlign="space-between" gap="2">
    <!-- <filter-component #popFilter width="130px"> </filter-component> -->

    <wiz-button
      #btnCancel
      class="cancel-button"
      [wizIcon]="'arrow-left'"
      (wizClick)="doCancel()"
      [wizLabel]="'$.common.cancel.$'"
    ></wiz-button>

    <wiz-button
      #btnSave
      [wizLabel]="'$.pivot.filterkey.edit.$'"
      [wizIcon]="'icon-arrow-right'"
      (click)="save()"
      [iconPlacement]="'right'"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
